import { Box, Checkbox, ListItem, Tooltip, Typography } from "@mui/material"
import { If } from "lib/@components/switch"
import Iconify from "minimals-template/components/Iconify"
import { LEGISLATION_FOLDER } from "authoring/routes/legislation-library/legislation-library-helpers"

export function AuthoringLegislationSelectorItem({
    item,
    onSelect,
    onToggle,
    selected,
    isTickable,
    getSelectionKey,
    disabledReason,
    getPath,
}) {
    const isFolder = item?.type === LEGISLATION_FOLDER
    const tickable = isTickable(item)
    const key = tickable ? getSelectionKey(item) : null
    const checked = tickable && selected.has(key)
    const reason = tickable ? disabledReason?.(item) ?? null : null
    const contextOnly = !tickable && !isFolder
    const disabled = !!reason || contextOnly
    const label = isFolder ? item?.name : item?.title
    const pathSegments = isFolder && getPath ? getPath(item.id) : null
    const path = pathSegments && pathSegments.length > 1 ? pathSegments.map((node) => node.name).join(" › ") : null

    const row = (
        <ListItem
            sx={{ borderBottom: 1, borderColor: "divider" }}
            data-cy={isFolder ? "legislation-group" : "legislation-item"}
        >
            <Box display="flex" alignItems="center" gap={1} width="100%">
                <If truthy={tickable}>
                    <Checkbox
                        checked={checked}
                        disabled={disabled}
                        onClick={(e) => e.stopPropagation()}
                        onChange={() => onToggle(item)}
                        data-cy="legislation-checkbox"
                    />
                </If>
                <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                    flex={1}
                    onClick={handleRowClick}
                    sx={{ cursor: isFolder || (tickable && !disabled) ? "pointer" : "default" }}
                >
                    <If truthy={isFolder}>
                        <Iconify
                            icon="material-symbols:folder"
                            sx={{ color: "primary.main", height: "25px", width: "25px" }}
                        />
                    </If>
                    <Box sx={{ minWidth: 0, flex: 1 }}>
                        <Typography color={disabled ? "text.disabled" : "text.primary"}>{label}</Typography>
                        <If truthy={!!path}>
                            <Typography variant="caption" color="text.disabled" noWrap data-cy="legislation-group-path">
                                {path}
                            </Typography>
                        </If>
                    </Box>
                </Box>
            </Box>
        </ListItem>
    )

    if (!reason) return row
    return (
        <Tooltip title={reason} slotProps={{ tooltip: { "data-cy": "legislation-disabled-reason" } }}>
            <span>{row}</span>
        </Tooltip>
    )

    function handleRowClick() {
        if (isFolder) {
            onSelect(item)
            return
        }
        if (tickable && !disabled) onToggle(item)
    }
}
